import { PAYMENT_METHOD_LIST } from './hooks/usePaymentMethod';
import { doSwaggerCall } from './hooks/useSwaggerClient';

export const activityAutocomplete = {};
activityAutocomplete.init = ids => {
    if ((ids.length === 1 && ids[0] === '') || ids.length === 0) {
        return [];
    }
    return doSwaggerCall('activities', 'getActivitiesForAdmins', {
        pageSize: ids.length,
        idList: ids
    }).then(({ activities }) =>
        activities.map(e => {
            const name = e.company?.name ? `${e.company?.name} > ${e.name}` : e.name;
            return { id: e.id, name: name };
        })
    );
};
activityAutocomplete.search = (search, pageSize) => {
    return doSwaggerCall('activities', 'getActivitiesForAdmins', {
        pageSize,
        search
    }).then(({ activities }) =>
        activities.map(e => {
            const name = e.company?.name ? `${e.company?.name} > ${e.name}` : e.name;
            return { id: e.id, name: name };
        })
    );
};

export const ticketAutocomplete = {};
ticketAutocomplete.init = ids => {
    if ((ids.length === 1 && ids[0] === '') || ids.length === 0) {
        return [];
    }
    return doSwaggerCall('tickets', 'listTickets', {
        pageSize: ids.length,
        idList: ids
    }).then(({ tickets }) =>
        tickets.map(e => {
            return { id: e.id, name: `${e.name}` };
        })
    );
};

ticketAutocomplete.search = (search, pageSize) => {
    return doSwaggerCall('tickets', 'listTickets', {
        pageSize,
        search
    }).then(({ tickets }) =>
        tickets.map(e => {
            return { id: e.id, name: `${e.name}` };
        })
    );
};

export const tagAutocomplete = {};
tagAutocomplete.init = ids => {
    return doSwaggerCall('tags', 'getAllTags', {
        pageSize: ids.length,
        idList: ids
    }).then(({ tags }) =>
        tags.map(e => {
            return { id: e.id, name: `${e.name}` };
        })
    );
};

tagAutocomplete.search = (search, pageSize) => {
    return doSwaggerCall('tags', 'getAllTags', {
        pageSize,
        search
    }).then(({ tags }) =>
        tags.map(e => {
            return { id: e.id, name: `${e.name}` };
        })
    );
};

export const clientAutocomplete = {};
clientAutocomplete.init = ids => {
    if ((ids.length === 1 && ids[0] === '') || ids.length === 0) {
        return [];
    }
    return doSwaggerCall('clients', 'listClients', {
        pageSize: ids.length,
        idList: ids
    }).then(({ clients }) =>
        clients.map(e => {
            return { id: e.id, name: `${e.name}` };
        })
    );
};

clientAutocomplete.search = (search, pageSize) => {
    return doSwaggerCall('clients', 'listClients', {
        pageSize,
        search
    }).then(({ clients }) =>
        clients.map(e => {
            return { id: e.id, name: `${e.name}` };
        })
    );
};

export const onlyVendorAutocomplete = {};
onlyVendorAutocomplete.init = (ids, vendorNumber) => {
    if ((ids.length === 1 && ids[0] === '') || ids.length === 0) {
        return [];
    }
    return doSwaggerCall('clients', 'listClients', {
        pageSize: ids.length,
        idList: ids,
        onlyVendors: true
    }).then(({ clients }) =>
        clients.map(e => {
            const response = {
                id: e.id,
                name: vendorNumber && e?.vendor_number ? `${e.name} [${e.vendor_number}]` : e.name
            };
            return response;
        })
    );
};

onlyVendorAutocomplete.search = (search, pageSize, vendorNumber = false) => {
    return doSwaggerCall('clients', 'listClients', {
        pageSize,
        search,
        onlyVendors: true
    }).then(({ clients }) =>
        clients.map(e => {
            const response = {
                id: e.id,
                name: vendorNumber && e?.vendor_number ? `${e.name} [${e.vendor_number}]` : e.name
            };
            return response;
        })
    );
};

export const onlyClientAutocomplete = {};
onlyClientAutocomplete.init = ids => {
    if ((ids.length === 1 && ids[0] === '') || ids.length === 0) {
        return [];
    }
    return doSwaggerCall('clients', 'listClients', {
        pageSize: ids.length,
        idList: ids,
        onlyClients: true
    }).then(({ clients }) =>
        clients.map(e => {
            return { id: e.id, name: `${e.name}` };
        })
    );
};

onlyClientAutocomplete.search = (search, pageSize) => {
    return doSwaggerCall('clients', 'listClients', {
        pageSize,
        search,
        onlyClients: true
    }).then(({ clients }) =>
        clients.map(e => {
            return { id: e.id, name: `${e.name}` };
        })
    );
};

export const userAutocomplete = {};
userAutocomplete.init = ids => {
    if ((ids.length === 1 && ids[0] === '') || ids.length === 0) {
        return [];
    }
    return doSwaggerCall('users', 'listUsers', {
        pageSize: ids.length,
        idList: ids
    }).then(({ users }) =>
        users.map(e => ({ id: e.id, name: `${e.firstname} ${e.lastname} (${e.email})` }))
    );
};

userAutocomplete.search = (search, pageSize) => {
    return doSwaggerCall('users', 'listUsers', {
        pageSize,
        search
    }).then(({ users }) =>
        users.map(e => ({ id: e.id, name: `${e.firstname} ${e.lastname} (${e.email})` }))
    );
};

export const userGroupAutocomplete = {};
userGroupAutocomplete.init = ids => {
    if (!Array.isArray(ids) || (ids.length === 1 && ids[0] === '') || ids.length === 0) {
        return [];
    }
    return doSwaggerCall('usergroups', 'getAllUserGroups', {
        pageSize: ids.length,
        idList: ids
    }).then(({ userGroups }) =>
        userGroups.map(e => {
            return { id: e.id, name: `${e.name}` };
        })
    );
};

userGroupAutocomplete.search = (search, pageSize) => {
    return doSwaggerCall('usergroups', 'getAllUserGroups', {
        pageSize,
        search
    }).then(({ userGroups }) =>
        userGroups.map(e => {
            return { id: e.id, name: `${e.name}` };
        })
    );
};

export const agentAutocomplete = {};
agentAutocomplete.init = ids => {
    if ((ids.length === 1 && ids[0] === '') || ids.length === 0) {
        return [];
    }
    return doSwaggerCall('users', 'listAgents', {
        pageSize: ids.length,
        idList: ids
    }).then(({ agents }) =>
        agents.map(e => ({ id: e.id, name: `${e.firstname} ${e.lastname} (${e.email})` }))
    );
};

agentAutocomplete.search = (search, pageSize) => {
    return doSwaggerCall('users', 'listAgents', {
        pageSize,
        search
    }).then(({ agents }) =>
        agents.map(e => ({ id: e.id, name: `${e.firstname} ${e.lastname} (${e.email})` }))
    );
};

export const agentsInChainAutocomplete = {};
agentsInChainAutocomplete.init = ids => {
    if ((ids.length === 1 && ids[0] === '') || ids.length === 0) {
        return [];
    }
    return doSwaggerCall('users', 'listAgentsInChain', {
        pageSize: ids.length,
        idList: ids
    }).then(({ agents }) =>
        agents.map(e => ({
            id: e.id === null ? 0 : e.id,
            name:
                e.id === 0
                    ? `${e.name}`
                    : `${e.name} (${e.email} - ${e.companyName ? e.companyName : ''})`
        }))
    );
};
agentsInChainAutocomplete.search = (search, pageSize) => {
    return doSwaggerCall('users', 'listAgentsInChain', {
        pageSize,
        search
    }).then(({ agents }) =>
        agents.map(e => ({
            id: e.id === null ? 0 : e.id,
            name:
                e.id === 0
                    ? `${e.name}`
                    : `${e.name} (${e.email} - ${e.companyName ? e.companyName : ''})`
        }))
    );
};

export const chainAutocomplete = {};
chainAutocomplete.init = ids => {
    if ((ids.length === 1 && ids[0] === '') || ids.length === 0) {
        return [];
    }
    return doSwaggerCall('chains', 'getAllChains', {
        pageSize: ids.length,
        idList: ids
    }).then(({ chains }) =>
        chains.map(e => {
            return { id: e.id, name: `${e.name}` };
        })
    );
};

chainAutocomplete.search = (search, pageSize) => {
    return doSwaggerCall('chains', 'getAllChains', {
        pageSize,
        search
    }).then(({ chains }) =>
        chains.map(e => {
            return { id: e.id, name: `${e.name}` };
        })
    );
};

export const discountPackageAutocomplete = {};
discountPackageAutocomplete.init = ids => {
    if ((ids.length === 1 && ids[0] === '') || ids.length === 0) {
        return [];
    }
    return doSwaggerCall('discountpackages', 'listDiscountPackagesPerClient', {
        pageSize: ids.length,
        idList: ids
    }).then(({ discountPackages }) =>
        discountPackages
            .filter(
                e =>
                    (e.discount.agencyDiscount.amount !== '' &&
                        e.discount.agencyDiscount.type !== '') ||
                    (e.discount.vendorDiscount.amount !== '' &&
                        e.discount.vendorDiscount.type !== '')
            )
            .map(e => {
                return { id: e.id, name: `${e.name}` };
            })
    );
};

discountPackageAutocomplete.search = (search, pageSize) => {
    return doSwaggerCall('discountpackages', 'listDiscountPackagesPerClient', {
        pageSize,
        search
    }).then(({ discountPackages }) =>
        discountPackages
            .filter(
                e =>
                    (e.discount.agencyDiscount.amount !== '' &&
                        e.discount.agencyDiscount.type !== '') ||
                    (e.discount.vendorDiscount.amount !== '' &&
                        e.discount.vendorDiscount.type !== '')
            )
            .map(e => {
                return { id: e.id, name: `${e.name}` };
            })
    );
};
discountPackageAutocomplete.searchOnlyItemLevel = (search, pageSize) => {
    return doSwaggerCall('discountpackages', 'listDiscountPackagesPerClient', {
        pageSize,
        search
    }).then(({ discountPackages }) =>
        discountPackages
            .filter(e => e.wholecart === false)
            .filter(
                e =>
                    (e.discount.agencyDiscount.amount !== '' &&
                        e.discount.agencyDiscount.type !== '') ||
                    (e.discount.vendorDiscount.amount !== '' &&
                        e.discount.vendorDiscount.type !== '')
            )
            .map(e => {
                return { id: e.id, name: `${e.name}` };
            })
    );
};
discountPackageAutocomplete.initOnlyCartLevel = (ids, clientId) => {
    if ((ids.length === 1 && ids[0] === '') || ids.length === 0) {
        return [];
    }
    const params = {
        pageSize: ids.length,
        idList: ids
    };
    if (clientId) {
        params.clientId = clientId;
    }
    return doSwaggerCall('discountpackages', 'listDiscountPackagesPerClient', params).then(
        ({ discountPackages }) =>
            discountPackages
                .filter(e => e.wholecart === true)
                .filter(
                    e =>
                        (e.discount.agencyDiscount.amount !== '' &&
                            e.discount.agencyDiscount.type !== '') ||
                        (e.discount.vendorDiscount.amount !== '' &&
                            e.discount.vendorDiscount.type !== '')
                )
                .map(e => {
                    return { ...e.discount, id: e.id, name: `${e.name}` };
                })
    );
};

discountPackageAutocomplete.searchOnlyCartLevel = (search, pageSize, clientId) => {
    const params = {
        pageSize,
        search
    };
    if (clientId) {
        params.clientId = clientId;
    }
    return doSwaggerCall('discountpackages', 'listDiscountPackagesPerClient', params).then(
        ({ discountPackages }) =>
            discountPackages
                .filter(e => e.wholecart === true)
                .filter(
                    e =>
                        (e.discount.agencyDiscount.amount !== '' &&
                            e.discount.agencyDiscount.type !== '') ||
                        (e.discount.vendorDiscount.amount !== '' &&
                            e.discount.vendorDiscount.type !== '')
                )
                .map(e => {
                    return { ...e.discount, id: e.id, name: `${e.name}` };
                })
    );
};

export const apiActivityAutocomplete = {};

apiActivityAutocomplete.init = (
    ids,
    service = 'Fareharbor', // ENUM!
    serviceApiKey = null,
    serviceApiUrl = null
) => {
    if ((ids.length === 1 && ids[0] === '') || ids.length === 0) {
        return [];
    }

    return doSwaggerCall('activities', 'getApiActivitiesForAdmins', {
        pageSize: ids.length,
        idList: ids,
        service,
        serviceApiKey,
        serviceApiUrl
    }).then(({ activities }) =>
        activities.map(e => ({
            id: e.id,
            name: `${e.name} (${e.company_name})`
        }))
    );
};

apiActivityAutocomplete.search = (
    search,
    pageSize,
    service = 'Fareharbor', // ENUM!
    serviceApiKey = null,
    serviceApiUrl = null
) => {
    return doSwaggerCall('activities', 'getApiActivitiesForAdmins', {
        pageSize,
        search,
        service,
        serviceApiKey,
        serviceApiUrl
    }).then(({ activities }) =>
        activities.map(e => ({
            id: e.id,
            name: `${e.name} (${e.company_name})`
        }))
    );
};

export const sourceGroupAutocomplete = {};
sourceGroupAutocomplete.init = ids => {
    if ((ids.length === 1 && ids[0] === '') || ids.length === 0) {
        return [];
    }
    return doSwaggerCall('sourcegroups', 'listSourceGroups', {
        pageSize: ids.length,
        idList: ids
    }).then(({ items }) =>
        items.map(e => {
            return { id: e.id, name: `${e.name}` };
        })
    );
};
sourceGroupAutocomplete.search = (search, pageSize) => {
    return doSwaggerCall('sourcegroups', 'listSourceGroups', {
        pageSize,
        search
    }).then(({ items }) =>
        items.map(e => {
            return { id: e.id, name: `${e.name}` };
        })
    );
};

export const sourceAutocomplete = {};
sourceAutocomplete.init = ids => {
    if ((ids.length === 1 && ids[0] === '') || ids.length === 0) {
        return [];
    }
    return doSwaggerCall('sources', 'listSources', {
        pageSize: ids.length,
        idList: ids
    }).then(({ items }) =>
        items.map(e => {
            return { id: e.id, name: `${e.name}` };
        })
    );
};
sourceAutocomplete.search = (search, pageSize) => {
    return doSwaggerCall('sources', 'listSources', {
        pageSize,
        search
    }).then(({ items }) =>
        items.map(e => {
            return { id: e.id, name: `${e.name}` };
        })
    );
};

export const cancelReasonAutocomplete = {};
cancelReasonAutocomplete.init = ids => {
    if ((ids.length === 1 && ids[0] === '') || ids.length === 0) {
        return [];
    }
    return doSwaggerCall('cancelreasons', 'getAllCancelReasons', {
        pageSize: ids.length,
        idList: ids
    }).then(({ cancelReasons }) =>
        cancelReasons.map(e => {
            return { id: e.id, name: `${e.name}`, description: e.description };
        })
    );
};

cancelReasonAutocomplete.search = (search, pageSize) => {
    return doSwaggerCall('cancelreasons', 'getAllCancelReasons', {
        pageSize,
        search
    }).then(({ cancelReasons }) =>
        cancelReasons.map(e => {
            return { id: e.id, name: `${e.name}`, description: e.description };
        })
    );
};

export const paymentMethodAutocomplete = {};
paymentMethodAutocomplete.init = ids => {
    if ((ids.length === 1 && ids[0] === '') || ids.length === 0) {
        return Promise.resolve([]);
    }
    const options = PAYMENT_METHOD_LIST;

    if (ids.length > 0) {
        return Promise.resolve(
            options
                .filter(e => ids.includes(e.id))
                .map(e => {
                    return { id: e.id, name: `${e.name}` };
                })
        );
    }

    return Promise.resolve(
        options.map(e => {
            return { id: e.id, name: `${e.name}` };
        })
    );
};

paymentMethodAutocomplete.search = search => {
    const options = PAYMENT_METHOD_LIST;
    if (search && search !== '') {
        return Promise.resolve(
            options
                .filter(e => e.name.toLowerCase().includes(search.toLowerCase()))
                .map(e => {
                    return { id: e.id, name: `${e.name}` };
                })
        );
    }

    return Promise.resolve(
        options.map(e => {
            return { id: e.id, name: `${e.name}` };
        })
    );
};

export const logTypeAutocomplete = {};
logTypeAutocomplete.init = async ids => {
    if ((ids.length === 1 && ids[0] === '') || ids.length === 0) {
        return [];
    }
    const { items } = await doSwaggerCall('auditlog', 'getLogTypes');
    return items.map(e => ({ id: e, name: e }));
};

logTypeAutocomplete.search = search => {
    return doSwaggerCall('auditlog', 'getLogTypes', {
        search
    }).then(({ items }) =>
        items.map(e => {
            return { id: e, name: e };
        })
    );
};

export const priceItemAutocomplete = {};
priceItemAutocomplete.init = ids => {
    if ((ids.length === 1 && ids[0] === '') || ids.length === 0) {
        return [];
    }
    return doSwaggerCall('priceitemnames', 'getAllPriceItemNames', {
        pageSize: ids.length,
        idList: ids
    }).then(({ price_item_names }) =>
        price_item_names.map(e => {
            return { id: e.id, name: `${e.name}` };
        })
    );
};

priceItemAutocomplete.search = (search, pageSize) => {
    return doSwaggerCall('priceitemnames', 'getAllPriceItemNames', {
        pageSize,
        search
    }).then(({ price_item_names }) =>
        price_item_names.map(e => {
            return { id: e.id, name: `${e.name}` };
        })
    );
};

export const islandAutocomplete = {};
islandAutocomplete.init = (ids, islandList) => {
    if ((ids.length === 1 && ids[0] === '') || ids.length === 0) {
        return [];
    }
    return doSwaggerCall('islands', 'getAllIslands', {
        pageSize: ids.length,
        idList: ids,
        islandList
    }).then(({ islands }) =>
        islands.map(e => {
            return { id: e.id, name: `${e.name}` };
        })
    );
};

islandAutocomplete.search = (search, pageSize, islandList) => {
    return doSwaggerCall('islands', 'getAllIslands', {
        pageSize,
        search,
        islandList
    }).then(({ islands }) =>
        islands.map(e => {
            return { id: e.id, name: `${e.name}` };
        })
    );
};

export const hotelAutocomplete = {};
hotelAutocomplete.init = (ids, islandId) => {
    if ((ids.length === 1 && ids[0] === '') || ids.length === 0) {
        return [];
    }
    return doSwaggerCall('hotels', 'getHotels', {
        pageSize: ids.length,
        idList: ids,
        islandId
    }).then(({ hotels }) =>
        hotels.map(e => {
            return { id: e.id, name: `${e.name}` };
        })
    );
};

hotelAutocomplete.search = (search, pageSize, islandId) => {
    return doSwaggerCall('hotels', 'getHotels', {
        pageSize,
        search,
        islandId
    }).then(({ hotels }) =>
        hotels.map(e => {
            return { id: e.id, name: `${e.name}` };
        })
    );
};

export const bookingStatusAutocomplete = {};

const STATUS_ITEMS = [
    { id: 'unconfirmed', name: 'Unconfirmed' },
    { id: 'confirmed', name: 'Confirmed' },
    { id: 'denied', name: 'Denied' },
    { id: 'cancelled', name: 'Cancelled' },
    { id: 'cancelled_full_refund', name: 'Cancelled (Full Refund)' }
];

bookingStatusAutocomplete.init = async ids => {
    if ((ids.length === 1 && ids[0] === '') || ids.length === 0) {
        return [];
    }

    // If ids provided -> filter, otherwise return all
    return STATUS_ITEMS.filter(item => ids.includes(item.id));
};

bookingStatusAutocomplete.search = search => {
    const term = (search || '').toLowerCase();

    return Promise.resolve(
        STATUS_ITEMS.filter(
            item => item.id.toLowerCase().includes(term) || item.name.toLowerCase().includes(term)
        )
    );
};
